/* eslint-disable no-restricted-imports */
import { Box, IconButton, TextField } from '@material-ui/core';
import { Add as AddIcon, Remove as RemoveIcon } from '@material-ui/icons';

import PropTypes from 'prop-types';

import { useStyles } from './styles';

export default function QuantityControl({
  value,
  onChange,
  min = 0,
  max = Infinity,
  disabled = false,
}) {
  const classes = useStyles();

  const handleIncrement = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  const handleDecrement = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleChange = (e) => {
    const newValue = parseInt(e.target.value) || min;
    const clampedValue = Math.max(min, Math.min(max, newValue));
    onChange(clampedValue);
  };

  return (
    <Box className={classes.container}>
      <IconButton
        size='small'
        onClick={handleDecrement}
        disabled={disabled || value <= min}
        className={classes.button}
      >
        <RemoveIcon fontSize='small' />
      </IconButton>
      <TextField
        type='number'
        value={value}
        onChange={handleChange}
        disabled={disabled}
        inputProps={{
          min,
          max,
          style: { textAlign: 'center' },
        }}
        className={classes.input}
        variant='outlined'
        size='small'
      />
      <IconButton
        size='small'
        onClick={handleIncrement}
        disabled={disabled || value >= max}
        className={classes.button}
      >
        <AddIcon fontSize='small' />
      </IconButton>
    </Box>
  );
}

QuantityControl.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  disabled: PropTypes.bool,
};
